import { render, staticRenderFns } from "./TwoFactorAuthenticationEnabled.vue?vue&type=template&id=b30b29c8&"
import script from "./TwoFactorAuthenticationEnabled.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationEnabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports